import { useEffect, useState } from 'react';
export const StyledButton = ({ onClick, children, disabled, className = '' }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return (
      <button 
        onClick={onClick}
        disabled={disabled}
        className={`relative inline-flex h-12 items-center justify-center rounded-md bg-transparent px-6 font-medium text-neutral-600 active:bg-neutral-100 ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      >
        {children}
      </button>
    );
  }

  return (
    <button 
      onClick={onClick}
      disabled={disabled}
      className={`group relative ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      <div className="relative z-10 inline-flex h-12 items-center justify-center overflow-hidden rounded-md  bg-transparent px-6 font-medium text-neutral-600 transition-all duration-300 group-hover:-translate-x-3 group-hover:-translate-y-3">
        {children}
      </div>
      <div className="absolute bg-white inset-0 z-0 h-full w-full rounded-md transition-all border border-neutral-300 duration-300 group-hover:-translate-x-3 group-hover:-translate-y-3 group-hover:[box-shadow:5px_5px_#a3a3a3,10px_10px_#d4d4d4,15px_15px_#e5e5e5]">
      </div>
    </button>
  );
};